import script from "./emoji-picker.vue?vue&type=script&lang=ts&setup=true"
export * from "./emoji-picker.vue?vue&type=script&lang=ts&setup=true"

import "./emoji-picker.vue?vue&type=style&index=0&id=5744beff&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5744beff"]])

export default __exports__